<app-header></app-header>
<app-side-nav></app-side-nav>

@if (bonusStore.bonusStorePage$ | async; as bonusStorePage) {
  <div class="bonus-shop">
    @if (bonusStorePage[0]?.SeoTitle) {
      <h1 class="bonus-shop__title">{{ bonusStorePage[0]?.SeoTitle }}</h1>
    } @else {
      <div class="bonus-shop__title">
        {{ bonusStorePage[0]?.TopTitle }}
      </div>
    }
    @if (easter.isFirstExist && easter.eventEnable) {
      <img (click)="easter.addEventToCollection(EventType.First)"
           src="/assets/img/promo/easter/egg.png" alt=""
           class="hunt">
    }
    <div class="container">
      <div class="tabs">
        <app-tabs #tabs (select)="onSelectTab($event)">
          <app-tab-item #coinsTab [tabTitle]="'t.for-coins' | translate" [id]="BONUS_SHOP_TYPE.COINS">
            @if (activeTab === coinsTab) {
              <div class="tab__item">
                <app-bonus-shop-tab [bonusStorePage]="bonusStorePage[0]"
                                    [bonusShopType]="BONUS_SHOP_TYPE.COINS"></app-bonus-shop-tab>
              </div>
            }
          </app-tab-item>
          <app-tab-item #cashTab [tabTitle]="'t.for-cash' | translate" [id]="BONUS_SHOP_TYPE.CASH">
            @if (activeTab === cashTab) {
              <div class="tab__item">
                <app-bonus-shop-tab [bonusStorePage]="bonusStorePage[1]"
                                    [bonusShopType]="BONUS_SHOP_TYPE.CASH"></app-bonus-shop-tab>
              </div>
            }
          </app-tab-item>
        </app-tabs>
      </div>
    </div>
    <div class="container">

    </div>
  </div>

  <app-bottom-navigation></app-bottom-navigation>
  <app-footer></app-footer>
} @else {
  <div class="preload-container preloading"></div>
}
